export default function hpUiSelect() {
    return {
        require: 'uiSelect',
        restrict: 'A',
        link(scope, element, attrs, $select) {
            scope.$watch('$select.items', (newValue) => {
                if (newValue.length === 0) {
                    scope.$emit('hpUiSelectNoChoice', { Name: attrs.hpUiSelectName, Value: $select.search });
                }
            });
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/common/angular/directives/hpUISelect.directive.js